<script setup>
import ShoppingCartLine from "@/Components/Blocks/ShoppingCart/ShoppingCartLine.vue";
import LinkButton from "@/Components/Buttons/Link.vue";
import {useCart} from "@/stores/cart";
import {usePage} from "@inertiajs/vue3";
import {inject} from "vue";

const cart = useCart();
/** @type import('ziggy-js').default */
const route = inject("route");

</script>

<template>
    <div class="container mb-30 mt-10 flex flex-col gap-8">
        <h2 class="text-2xl font-bold uppercase">
            {{ $t("Shopping cart") }}
        </h2>
        <div class="flex flex-1 flex-col gap-8">
            <div
                v-if="!cart.hasProductVariants"
                class=" text-6"
            >
                {{ $t("Your shopping cart is empty") }}
            </div>
            <div class="flex flex-col gap-8 divide-y-px">
                <div
                    v-for="variant in cart.productVariants"
                    :key="variant.id"
                    class="flex pt-8"
                >
                    <ShoppingCartLine :variant="variant" />
                </div>
            </div>
        </div>
        <div
            v-if="cart.hasProductVariants"
            class="flex justify-end"
        >
            <div class="w-full sm:max-w-120">
                <div class="mb-8 grid grid-cols-3 gap-x-0 gap-y-4">
                    <span />
                    <h4 class="col-span-2 text-right font-bold">
                        {{ $t("Subtotal") }}
                    </h4>

                    <div class="col-span-2" />
                    <div class="text-right">
                        {{ $n(cart.product_display_total / 100, "currency").replace("€", "EUR") }}
                    </div>
                </div>

                <div class="mt-2 flex justify-end">
                    <LinkButton
                        :href="
                            route('public.pages.show', { slug: usePage().props.commerceSettings.checkout_page_slug })
                        "
                        :label="$t('Checkout')"
                    />
                </div>
            </div>
        </div>
    </div>
</template>
